import { EstadosActivacionEnumChoice } from '@/shared';
import { ChipModelState } from '@/shared/components/ui';

export type EstadoActivacionComponentProps = {
  estado: string;
};

const EstadoActivacionComponent: React.FC<EstadoActivacionComponentProps> = ({
  estado,
}) => {
  return (
    <>
      {estado === EstadosActivacionEnumChoice.EN_ESPERA.toUpperCase() ? (
        <ChipModelState color="success" label="En Espera" />
      ) : estado === EstadosActivacionEnumChoice.PRE_RECHAZADA.toUpperCase() ? (
        <ChipModelState color="warning" label={EstadosActivacionEnumChoice.PRE_RECHAZADA} />
      ) : estado === EstadosActivacionEnumChoice.RECHAZADA.toUpperCase() ? (
        <ChipModelState color="error" label={EstadosActivacionEnumChoice.RECHAZADA} />
      ) : estado === EstadosActivacionEnumChoice.GESTIONADA.toUpperCase() ? (
        <ChipModelState color="success" label={EstadosActivacionEnumChoice.GESTIONADA} />
      ) : estado === EstadosActivacionEnumChoice.CANCELADO.toUpperCase() ? (
        <ChipModelState color="warning" label={EstadosActivacionEnumChoice.CANCELADO} />
      ) : estado === EstadosActivacionEnumChoice.FINALIZADO.toUpperCase() ? (
        <ChipModelState color="success" label={EstadosActivacionEnumChoice.FINALIZADO} />
      ) : estado === EstadosActivacionEnumChoice.PENDIENTE_CAMBIO_PUERTO.toUpperCase() ? (
        <ChipModelState color="warning" label={EstadosActivacionEnumChoice.PENDIENTE_CAMBIO_PUERTO} />
      ) : (
        'N/A'
      )}
    </>
  );
};

export default EstadoActivacionComponent;
